import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDarkmode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.7 17.7",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M12,11.9c1,0,2-.3,2.9-.9-.4,1.2-1.2,2.1-2.2,2.8s-2.2,1.1-3.5,1.1-1.6-.2-2.4-.5-1.4-.7-2-1.3-1-1.2-1.3-1.9-.5-1.5-.5-2.3.2-1.6.5-2.3.8-1.4,1.3-1.9,1.2-1,2-1.3,1.6-.5,2.4-.5c-.7.4-1.2,1-1.6,1.8s-.6,1.5-.6,2.3.1,1.3.4,1.9.6,1.1,1.1,1.6,1,.8,1.6,1.1,1.3.4,2,.4Z"
	})
});
export default SvgDarkmode;
